import { callGet, callPost, callPostForBlob } from '../../services/axios'
import { toast } from '../../components/CommonComponents/ToastComponent/toast'
import { Redirect } from "react-router-dom"
import React from 'react'

import {
  DO_SIGNUP_START,
  DO_SIGNUP_SUCCESS,
  DO_SIGNUP_FAILED,
  DO_VERIFY_EMAIL_SUCCEED,
  DO_LOGIN_START,
  DO_LOGIN_SUCCESS,
  DO_LOGIN_FAILED,
  LOGOUT_SUCCESS,
  DO_LOGGED_IN_WITH_DOMAIN,
  DO_SET_AUTH_INFO,
  DO_REMOVE_AUTH_INFO,
  UPDATE_USER_START,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILED,
  UPDATE_PASSWORD_START,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILED,
  UPLOAD_PROFILE_START,
  UPLOAD_PROFILE_SUCCESS,
  UPLOAD_PROFILE_FAILED
} from '../actionTypes/auth'

export const doLogin = ({ email, password }) => (dispatch) => {
  dispatch(doLoginStart())
  return callPost(`/api/auth/signin`, {
    email,
    password
  }).then((res) => {
    dispatch(doLoginSuccess(res['data']))
    dispatch(autoLogOutTimer())
  }).catch((err) => {
    dispatch(doLoginFailed())
    toast.show({
      title: 'Warning',
      description: err.response.data.message ? err.response.data.message : 'Server error. Failed to login',
    })
    return Promise.reject(err)
  })
}
export const doLoginStart = () => {
  return { type: DO_LOGIN_START }
}
export const doLoginSuccess = (data) => {
  return { type: DO_LOGIN_SUCCESS, data }
}
export const doLoginFailed = () => {
  return { type: DO_LOGIN_FAILED }
}

export const doSignup = ({ email, password, firstName, lastName, userName }) => (dispatch) => {
  dispatch(doSignupStart())
  return callPost(`/api/auth/signup`, {
    email,
    password,
    firstname: firstName,
    lastname: lastName,
    username: userName,
  }).then(() => {
    dispatch(doSignupSuccess())
    toast.show({
      title: 'Success',
      description: 'Verification Email is sent. Please check your eamil.',
    })
  }).catch((err) => {
    dispatch(doSignupFailed())
    toast.show({
      title: 'Warning',
      description: err.response.data.message ? err.response.data.message : 'Server error. Failed to login',
    })
    return Promise.reject(err)
  })
}

export const doSignupStart = () => {
  return { type: DO_SIGNUP_START }
}
export const doSignupSuccess = (data) => {
  return { type: DO_SIGNUP_SUCCESS, data }
}
export const doSignupFailed = () => {
  return { type: DO_SIGNUP_FAILED }
}

export const doLogOut = () => (dispatch) => {
  dispatch({
    type: LOGOUT_SUCCESS,
  })
  var localStorageObject = JSON?.parse(localStorage.getItem('persist:root'))
  var localAuthObject = {
    isLoading: false,
    isLoggedIn: false,
    token: '',
    user: {},
    subdomain: ''
  }

  let localEmailSettingsObj = {
    authEmails: [],
    isLoading: false,
    token: '',
    userId: ''
  } 

  Object.keys(localStorageObject).forEach(key => {
    if (key === 'auth') {
      localStorageObject[key] = JSON?.stringify(localAuthObject)
    }

    if (key === 'emailSettings') {
      localStorageObject[key] = JSON?.stringify(localEmailSettingsObj)
    }
  });

  localStorage.setItem('persist:root', JSON?.stringify(localStorageObject))
}

export const verifyEmail = (verificationString) => (dispatch) => {
  return callGet(`/api/auth/verify/${verificationString}`).then((res) => {
    dispatch({
      type: DO_VERIFY_EMAIL_SUCCEED,
      data: res.data
    })
    toast.show({
      title: 'Success',
      description: res.data.message || 'Your account is activated successfully.',
    })
  }).catch((error) => {
    toast.show({
      title: 'Warning',
      description: 'Try again',
    })
    return Promise.reject('Can not activate your account.')
  })
}

export const resendEmail = (email) => () => {
  return callGet(`/api/auth/resendVerifyEmail/${email}`).then((res) => {
    toast.show({
      title: 'Success',
      description: 'Sent verification code successfully!',
    })
  }).catch((error) => {
    toast.show({
      title: 'Warning',
      description: 'Try again!',
    })
    return Promise.reject('Can not send verification code.')
  })
}

export const doLoggedInWithDomain = () => (dispatch) => {
  dispatch({
    type: DO_LOGGED_IN_WITH_DOMAIN,
  })
}

export const doRemoveAuthInfo = () => (dispatch) => {
  dispatch({
    type: DO_REMOVE_AUTH_INFO,
  })
}

export const doSetAuthInfo = ({ user, token }) => (dispatch) => {
  dispatch({
    type: DO_SET_AUTH_INFO,
    data: {
      user: user,
      token: token,
    }
  })
}


export const doForgotPassword = ({ email }) => () => {
  return callPost(`/api/auth/forgotpassword`, {
    email,
  }).then(() => {
    toast.show({
      title: 'Success',
      description: 'Reset Password Email is sent. Please check your email.',
    })
  }).catch((err) => {
    toast.show({
      title: 'Warning',
      description: err.response.data.message ? err.response.data.message : 'Server error. Failed to send mail',
    })
    return Promise.reject(err)
  })
}

export const doResetPassword = ({ email, hash, password }) => () => {
  return callPost(`/api/auth/resetpassword`, {
    email,
    hash,
    password
  }).then(() => {
    toast.show({
      title: 'Success',
      description: 'Password Reset Successfully. Please LogIn with your new password',
    })
  }).catch((err) => {
    toast.show({
      title: 'Warning',
      description: err.response.data.message ? err.response.data.message : 'Server error. Failed to reset password',
    })
    return Promise.reject(err)
  })
}

// Function to auto log out after 24 hours
export const autoLogOutTimer = () => async (dispatch, getState) => {
  const { auth: { user } } = getState()
  if (user && Object.values(user).length > 0) {
    const decodedJwt = parseJwt(user.accessToken);
    const expires = new Date(decodedJwt.exp * 1000);
    const timeout = expires.getTime() - Date.now();
    setTimeout(() => {
      dispatch(doLogOut())
      toast.show({
        title: 'Warning',
        description: 'Your session has been expired. Please login again.'
      })
      return (
        <Redirect
          to='/login'
        />
      )
    }, timeout);
  }
}

const parseJwt = (token) => {
  try {
    return JSON?.parse(window.atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};

export const updateUserStart = () => {
  return { type: UPDATE_USER_START }
}
export const updateUserSuccess = (data) => {
  return { type: UPDATE_USER_SUCCESS, data }
}
export const updateUserFailed = () => {
  return { type: UPDATE_USER_FAILED }
}

export const updateUser = (userName, id) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  dispatch(updateUserStart())
  return callPost(`/api/auth/updateUser`, { userName, id }, token).then((res) => {
    dispatch(updateUserSuccess(res['data'][1][0]))
    return Promise.resolve(res['data'])
  }).catch(err => {
    dispatch(updateUserFailed())
    return Promise.reject()
  })
}

export const updatePasswordStart = () => {
  return { type: UPDATE_PASSWORD_START }
}
export const updatePasswordSuccess = (data) => {
  return { type: UPDATE_PASSWORD_SUCCESS, data }
}
export const updatePasswordFailed = () => {
  return { type: UPDATE_PASSWORD_FAILED }
}

export const updatePassword = (newPassword, id) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  dispatch(updateUserStart())
  return callPost(`/api/auth/updatePassword`, { newPassword, id }, token).then((res) => {
    dispatch(updateUserSuccess(res['data'][1][0]))
    return Promise.resolve(res['data'])
  }).catch(err => {
    dispatch(updateUserFailed())
    return Promise.reject()
  })
}



export const uploadFileToS3Bucket = (file, id) => (dispatch, getState) => {
  let formData = new FormData()
  formData.append('file', file)
  formData.append('userId', id)
  const { auth: { token } } = getState()
  return callPost(`/api/auth/uploadFileToS3Bucket`, formData, token).then((res) => {
    dispatch(uploadProfileSuccess(res.data[1][0]))
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}


export const uploadProfileStart = () => {
  return { type: UPLOAD_PROFILE_START }
}
export const uploadProfileSuccess = (data) => {
  return { type: UPLOAD_PROFILE_SUCCESS, data }
}
export const uploadProfileFailed = () => {
  return { type: UPLOAD_PROFILE_FAILED }
}

// export const downloadFileFromS3Bucket = (filename) => (dispatch, getState) => {
//   const { auth: { token } } = getState()
//   dispatch(uploadProfileStart())
//   return callPostForBlob('/api/supplier/downloadFileFromS3Bucket', { filename }, token).then(res => {
//     dispatch(uploadProfileSuccess(res.data))
//     return Promise.resolve(res['data'])
//   }).catch(err => {
//     dispatch(uploadProfileFailed())
//     return Promise.resolve({err})
//   })
// }

export const sendMail = (email, subject, content, attachment = false, filePath = null) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  dispatch(updateUserStart())
  return callPost(`/api/auth/sendMail`, { email, subject, content, attachment, filePath }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject()
  })
}

export const getUserInfo = (userId) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost('/api/auth/getUserInfo', { userId }, token).then(res => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.resolve({err})
  })
}